import "./TehnicLock.css"
import strings from "../../../locales/ro.json"
import { useState } from "react";
import requestHandler from "../../../utils/requestHandler";

const TehnicLock = ({isAdmin, active, token}) => {
	let id = isAdmin ? "" : "hideButton";
	
	function closePopup(){
		if(!token) return;
		const myAuthToken = `Bearer ${token}`;
		requestHandler("handrules/69/pop", "GET", myAuthToken);
	}

	return active ? (
		<div className="tehnicLockContainer">
			<div className="popupBox">
				<div className="warningSign">
					<img src="./icons/warning.svg" alt="tehnic warning"/>
				</div>
				<div className="tlTitle">{strings.handrules.tehnicLock.title}</div>
				<div className="tlInfo">{strings.handrules.tehnicLock.info}</div> 
				<div className="tlButton" style={isAdmin? {opacity: "0"} : {}} onClick={closePopup}>{strings.handrules.tehnicLock.resolved}</div>
			</div>
		</div>
	) : undefined;
}

export default TehnicLock;